var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntDesignFacebookFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_9355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2353 0H1.15531C0.624312 0 0.195312 0.429 0.195312 0.96V23.04C0.195312 23.571 0.624312 24 1.15531 24H23.2353C23.7663 24 24.1953 23.571 24.1953 23.04V0.96C24.1953 0.429 23.7663 0 23.2353 0ZM20.4633 7.005H18.5463C17.0433 7.005 16.7523 7.719 16.7523 8.769V11.082H20.3403L19.8723 14.703H16.7523V24H13.0113V14.706H9.88231V11.082H13.0113V8.412C13.0113 5.313 14.9043 3.624 17.6703 3.624C18.9963 3.624 20.1333 3.723 20.4663 3.768V7.005H20.4633Z",
    fill: "#335BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_9355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.195312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignFacebookFilled);
export default __webpack_public_path__ + "static/media/ant-design_facebook-filled.88dd0c558055dd45d2eb2a9ebf8a2bf9.svg";
export { ForwardRef as ReactComponent };